module.exports = __webpack_public_path__ + "img/png09.d7a17d1e.png";